import { Button, Text } from '@wework/dieter-ui'
import React, { FunctionComponent } from 'react'
import IMTheme from '../../../style/IMTheme'
import { getProductName, getProductType } from '../../../utils/spaces'
import Row from '../../Common/Row'
import CloseIcon from '../../../assets/images/CloseIcon.svg'
import notLinkedIcon from '../../../assets/icons/notLinkedIcon.png'

interface ProductNameHeaderProps {
  space: any
  isLinked?: boolean
  onClose: () => void
}

const ProductNameHeader: FunctionComponent<ProductNameHeaderProps> = ({
  space,
  isLinked = false,
  onClose,
}) => {
  return (
    <Row justify="space-between" style={{ alignItems: 'start' }}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        <Text
          style={{
            fontWeight: IMTheme.fontWeights.bold,
            fontSize: IMTheme.fontSizes[3],
            textTransform: 'capitalize',
          }}
        >
          Inventory
        </Text>
        {isLinked ? (
          <>
            <Text style={{ fontSize: IMTheme.fontSizes[5] }}>
              {getProductName(space)}
            </Text>
            <Text
              style={{
                textTransform: 'capitalize',
                fontSize: IMTheme.fontSizes[2],
              }}
            >
              {getProductType(space)}
            </Text>
          </>
        ) : (
          <Text
            style={{
              fontSize: IMTheme.fontSizes[2],
            }}
          >
            <img
              src={notLinkedIcon}
              style={{ width: 20, height: 20, marginRight: 2 }}
            />
            {'Not linked'}
          </Text>
        )}
      </div>
      <Button
        basic
        onClick={onClose}
        icon={
          <div style={{ width: 18, height: 18 }}>
            <CloseIcon />
          </div>
        }
        style={{
          margin: 0,
        }}
      />
    </Row>
  )
}

export default ProductNameHeader
